import React, { useContext } from 'react';

const StepContext = React.createContext();

export function useStep() {
  return useContext(StepContext);
}

export default StepContext;